import { render } from "./StepOneRegistration.vue?vue&type=template&id=54392757&scoped=true"
import script from "./StepOneRegistration.vue?vue&type=script&lang=js"
export * from "./StepOneRegistration.vue?vue&type=script&lang=js"

import "./StepOneRegistration.vue?vue&type=style&index=0&id=54392757&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54392757"]])

export default __exports__